<template>
  <div>
    <HomeHeader />
    <div ref="top" style="padding-top: 70px;width: 100%;min-height: 73.8vh">
      <el-container >
        <el-main style="padding: 20px 0;margin: 0 10%">
          <div class="content">
            <div class="content_left">
              <el-popover
                  placement="bottom"
                  width="700"
                  trigger="click"
                  >
                <div class="popover_body">
                  <div class="popover_head">
                    <img v-if="!detail.userInfo.headPortrait || detail.userInfo.headPortrait === ''" src="@/assets/img/forum/forum_user.png" alt="">
                    <img v-else :src="detail.userInfo.headPortrait" alt="">
                    <div class="popover_message">
                      <div>
                        <div style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width: 160px;" :title="detail.author">{{detail.author}}</div>
                        <div class="flag_icon_container" v-show="Number(detail.userInfo.adminRole) === 1">
                          <img class="flag_icon_item" src="@/assets/img/forum/official_flag.png" title="官方认证" alt="官方认证标志">
                        </div>
                        <div class="popover_tab">LV{{(!authorInfoPop.level || authorInfoPop.level === '0' ? '1' : authorInfoPop.level)}} {{authorInfoPop.levelName}}</div>
                      </div>
                      <div style="color: #999999;font-size: 14px;padding-top: 14px;justify-content: flex-start">
                        <div style="width:120px;">{{authorInfoPop.levelRumenOrZhuanye === '0' ? ' 产品原型设计' : '车载应用开发'}}</div>
                        <div style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width: 270px" :title="authorInfoPop.introduce === null || authorInfoPop.introduce === '' ? '暂无' : authorInfoPop.introduce">个人介绍：{{authorInfoPop.introduce === null || authorInfoPop.introduce === '' ? '暂无' : authorInfoPop.introduce}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="popover_foot">
                    <div>已发布的应用数：{{authorInfoPop.appSum}}</div>
                    <div>已发布的场景数：{{authorInfoPop.sceneSum}}</div>
                    <div>经验值：{{authorInfoPop.exp}}</div>
                    <div>性别： {{authorInfoPop.gender === '' || authorInfoPop.gender === null || authorInfoPop.gender === '0' ? '未公开' : (authorInfoPop.gender === '1' ? '男' : '女')}}</div>
                    <div>生日： {{!authorInfoPop.birthDay || authorInfoPop.birthDay === null || authorInfoPop.birthDay === '' ? '未公开' : authorInfoPop.birthDay}}</div>
                  </div>
                </div>
                <div slot="reference" class="content_user" >
                  <div class="content_img">
                    <img v-if="!list[0].userInfo.headPortrait || list[0].userInfo.headPortrait === ''" src="@/assets/img/forum/forum_user.png" alt="">
                    <img v-else :src="list[0].userInfo.headPortrait"  alt="">
                  </div>
                  <div class="content_name">
                    <div class="name_text" :title="list[0].userInfo.name">
                      {{list[0].userInfo.name}}
                    </div>
                    <div class="flag_icon_container" v-show="Number(list[0].userInfo.adminRole) === 1">
                      <img class="flag_icon_item" src="@/assets/img/forum/official_flag.png" title="官方认证" alt="官方认证标志">
                    </div>
                  </div>
                  <div class="content_tab">
                    <div v-if="!authorInfoPop.level || authorInfoPop.level === '0'">
                      LV1 开发新星
                    </div>
                    <div v-else>
                      LV{{authorInfoPop.level}} {{authorInfoPop.levelName}}
                    </div>
                  </div>
                  <div class="content_message">
                    <span>文章</span>
                    <el-divider direction="vertical"></el-divider>
                    <span>{{list[0].userInfo.article}}</span>
                  </div>
                </div>
              </el-popover>
            </div>
            <div class="comment_right">
              <div>
                <div style="display: flex;align-items: center;padding: 18px 5px;">
                  <div class="title">
                    {{list[0].title}}
                    <div class="tab1">{{channelName}}</div>
                    <div v-for="(item, index) in list[0].tags" :key="'tag' + index" class="tab">{{item}}</div>
                  </div>
                </div>
                <div class="time">
                  <div v-if="(list[0].createTime == list[0].updateTime)">
                    发表于：{{timeFormatSeconds(list[0].createTime)}}
                  </div>
                  <div v-else>
                    {{timeFormatSeconds(list[0].updateTime)}}&nbsp;被作者编辑过
                  </div>
                  <div>浏览量：{{list[0].views}}</div>
                </div>
              </div>
              <div class="comment_first">
                <div class="comment_first_content" v-html="list[0].content"></div>
              </div>
            </div>
          </div>
          <div v-if="list[1]" ref="comment1" class="comment">
            <div class="content_left">
              <el-popover
                  placement="bottom"
                  width="700"
                  trigger="click"
                  >
                <div class="popover_body">
                  <div class="popover_head">
                    <img v-if="!commentPop.header || commentPop.header === ''" src="@/assets/img/forum/forum_user.png" alt="">
                    <img v-else :src="commentPop.header" alt="">
                    <div class="popover_message">
                      <div>
                        <div style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width:160px" :title="commentPop.name">{{commentPop.name}}</div>
                        <div class="flag_icon_container" v-show="Number(commentPop.adminRole) === 1">
                          <img class="flag_icon_item" src="@/assets/img/forum/official_flag.png" title="官方认证" alt="官方认证标志">
                        </div>
                        <div class="popover_tab">LV{{commentPop.level || commentPop.level === '0' ? '1' : commentPop.level}} {{commentPop.levelName}}</div>
                      </div>
                      <div style="color: #999999;font-size: 14px;padding-top: 14px;justify-content: flex-start">
                        <div style="width:120px">{{commentPop.levelRumenOrZhuanye === '0' ? '产品原型设计' : '车载应用开发'}}</div>
                        <div style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width:270px" :title="commentPop.introduce === null || commentPop.introduce === '' ? '暂无' : commentPop.introduce">个人介绍：{{commentPop.introduce === null || commentPop.introduce === '' ? '暂无' : commentPop.introduce}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="popover_foot">
                    <div>已发布的应用数：{{commentPop.appSum}}</div>
                    <div>已发布的场景数：{{commentPop.sceneSum}}</div>
                    <div>经验值：{{commentPop.exp}}</div>
                    <div>性别： {{commentPop.gender === '' || commentPop.gender === null || commentPop.gender === '0' ? '未公开' : (commentPop.gender === '1' ? '男' : '女')}}</div>
                    <div>生日： {{!commentPop.birthDay || commentPop.birthDay === null || commentPop.birthDay === '' ? '未公开' : commentPop.birthDay}}</div>
                  </div>
                </div>
                <div slot="reference" class="comment_user" >
                  <div class="content_img">
                    <img v-if="!list[1].userInfo.headPortrait || list[1].userInfo.headPortrait === ''" src="@/assets/img/forum/forum_user.png" alt="">
                    <img v-else :src="list[1].userInfo.headPortrait"  alt="">
                  </div>
                  <div class="content_name">
                    <div class="name_text" :title="list[1].userInfo.name">
                      {{list[1].userInfo.name}}
                    </div>
                    <div class="flag_icon_container" v-show="Number(list[1].userInfo.adminRole) === 1">
                      <img class="flag_icon_item" src="@/assets/img/forum/official_flag.png" title="官方认证" alt="官方认证标志">
                    </div>
                  </div>
                  <div class="content_tab">
                    <div v-if="!commentPop.level || commentPop.level === '0'">
                      LV1 开发新星
                    </div>
                    <div v-else>
                      LV{{commentPop.level}} {{commentPop.levelName}}
                    </div>
                  </div>
                  <div class="content_message">
                    <span>文章</span>
                    <el-divider direction="vertical"></el-divider>
                    <span>{{list[1].userInfo.article}}</span>
                  </div>
                </div>
              </el-popover>
            </div>
            <div class="comment_right">
              <div class="comment_first">
                <div class="comment_first_content" v-html="list[1].content"></div>
                <div style="display: flex;align-items: center;justify-content: space-between;font-size:14px">
                  <div v-if="(list[1].createDate == list[1].publishDate)" class="comment_first_time" >回复于{{timeFormatSeconds(list[1].publishDate)}}</div>
                  <div v-else class="comment_first_time">{{timeFormatSeconds(list[1].publishDate)}}&nbsp;被作者编辑过</div>
                </div>
              </div>
              <div v-if="list[2]" class="comment_return">
                <div class="comment_return_content">
                  <img v-if="list[2].top === 1" src="@/assets/img/forum/forum_top.png" style="width: 24px;height: 24px;margin-right: 7px" alt="">
                  <img v-if="!list[2].userInfo.headPortrait || list[2].userInfo.headPortrait === ''" src="@/assets/img/forum/forum_user.png" alt="">
                  <img v-else :src="list[2].userInfo.headPortrait"  alt="">
                  <div class="name">{{userInfo.name != null ? userInfo.name : userInfo.email}}</div>
                  <div class="content" v-html="list[2].content"></div>
                </div>
                <div class="comment_return_time">
                  <div>发表于：{{timeFormatSeconds(list[2].publishDate)}}</div>
                </div>
              </div>
            </div>
          </div>
          <div style="text-align: right;font-size: 24px;color: #4d78ff;cursor: pointer;padding: 20px 0;" @click="toDetail()">
            跳转至原文
          </div>
        </el-main>
      </el-container>
    </div>
    <HomeFooter style="margin-top:0;position: relative;bottom: 0"/>
  </div>
</template>

<script>
import HomeHeader from '../../../components/HomeHeader'
import HomeFooter from '../../../components/HomeFooter'
import {
  getChannel,
  selectPersonalInfo,
  findComments
} from '@/api/modules/replyDetailForum'
import { getMilliData1 } from '@/scripts/dataTimeUtils'
export default {
  name: 'ReplyDetail',
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {
      divIndex: [],
      id: this.$route.query.id,
      targetId: this.$route.query.targetId,
      detail: {
        userInfo: {}
      },
      list: [],
      reference: {},
      // 控制渲染条件 如果不用v-if会报错 具体可自行尝试
      showPop: false,
      targetType: 'article',
      userId: this.getCookie('userid'),
      userInfo: {},
      reportForm: {},
      level: ['1'],
      authorInfoPop: {},
      channelName: '频道',
      editCommentData: null,
      commentPop: {},
      contentPagination: [],
      isEdit: false
    }
  },
  computed: {
  },
  created() {
    const user = JSON.parse(localStorage.getItem('usersCurrentInfo'))
    this.userInfo = user
    this.findComments()
  },
  mounted() {
  },
  methods: {
    toDetail() {
      this.$router.push({ path: '/forum/detail', query: { id: this.list[0].id }})
    },
    isLogin() {
      if (!this.getCookie('userid')) {
        this.$router.push('/login')
        return false
      }
      else {
        return true
      }
    },
    async getChannel() {
      if (this.detail.channelIds[0]) {
        const res = await getChannel(this.detail.channelIds[0])
        if (res.data.name) {
          this.channelName = res.data.name
        }
        else {
          this.channelName = '删除的频道'
        }
      }
      else {
        this.channelName = '删除的频道'
      }
    },
    async findComments() {
      const data = {
        targetId: this.id,
        targetType: 'comment',
        userId: this.userInfo.id
      }
      const res = await findComments(data)
      this.detail = res.data[0]
      this.list = res.data
      console.log(this.list)
      this.selectPersonalInfo(this.detail.userInfo.id)
      if (this.list[1]) {
        this.showContentPop(this.list[1].userInfo)
      }
      this.getChannel()
      return
    },
    async selectPersonalInfo(id) {
      const data = {
        userId: id
      }
      const res = await selectPersonalInfo(data)
      if (res.code === 0) {
        this.authorInfoPop = res.data
      }
    },
    getCookie(cname) {
      var name = cname + '='
      var ca = document.cookie.split(';')
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) === ' ') c = c.substring(1)
        if (c.indexOf(name) !== -1) {
          return c.substring(name.length, c.length)
        }
      }
      return ''
    },
    isNull(str) {
      if (str === '') return true
      var regu = '^[ ]+$'
      var re = new RegExp(regu)
      return re.test(str)
    },
    timeFormatSeconds(time) {
      var d = time ? new Date(time) : new Date()
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate()
      var hours = d.getHours()
      var min = d.getMinutes()
      var seconds = d.getSeconds()

      if (month < 10) month = '0' + month
      if (day < 10) day = '0' + day
      if (hours < 0) hours = '0' + hours
      if (min < 10) min = '0' + min
      if (seconds < 10) seconds = '0' + seconds

      return (year + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + seconds)
    },
    async showContentPop(user) {
      const data = {
        userId: user.id
      }
      const res = await selectPersonalInfo(data)
      if (res.code === 0) {
        this.commentPop = res.data
        this.commentPop.name = user.name
        this.commentPop.header = user.headPortrait
      }
    },
    getMilliData(time) {
      return getMilliData1(time)
    }
  }
}
</script>

<style scoped>
.comment{
  background-color: #FFFFFF;
  width: 100%;
  display: flex;
  color: #2F374B;
  min-height: 279px;
  border-top: 1px solid #DDDDDD;
}
.content{
  background-color: #FFFFFF;
  width: 100%;
  display: flex;
  color: #2F374B;
}
/deep/.content > p {
  line-height: 1.4;
  word-break: break-all;
  display: flex;
  align-items: center;
}
/*/deep/.content > p > * {*/
/*  vertical-align: bottom;*/
/*}*/
/deep/.content > p > img{
  max-height: 30px;
  margin: auto 10px;
}
/deep/.content > p > a{
  color: #4d78ff;
}
/deep/.comment_first_content > p > a {
  color: #4d78ff;
}
/deep/.comment_first_content > p > img {
  max-width: 100%;
}
.content_left{
  padding: 20px;
  box-sizing: border-box;
  width: 220px;
  height: 100%;
}
.content_user{
  background: url('~@/assets/img/forum/author_bg.png') no-repeat center bottom / 100% auto;
  width: 180px;
  height: 240px;
  padding: 18px 36px;
  box-sizing: border-box;
}
.comment_user{
  background: url('~@/assets/img/forum/user_bg.png') no-repeat center bottom / 100% auto;
  width: 180px;
  height: 240px;
  padding: 18px 36px;
  box-sizing: border-box;
}
.content_img{
  box-sizing: border-box;
  padding: 13px 17px 20px 22px;
}
.content_img > img {
  border-radius: 50%;
  width: 69px;
  height: 69px;
}
.content_name{
  text-align: center;
  font-size: 18px;
  color: #2F374B;
  display: flex;
}
.content_name > .name_text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.content_tab{
  padding: 12px 0;
  text-align: center;
}
.popover_tab{
  border: 1px solid #4D78FF;
  font-size: 14px;
  line-height: 1;
  border-radius: 12px;
  padding: 5px 10px;
  box-sizing: border-box;
  color: #4D78FF;
  margin-left: 20px;
}
.content_tab > div{
  border: 1px solid #4D78FF;
  font-size: 14px;
  line-height: 1;
  border-radius: 12px;
  padding: 5px 8px;
  box-sizing: border-box;
  color: #4D78FF;
}
.content_message{
  padding: 10px 0px 22px;
  display: flex;
  align-items: center;
}
.content_message > span {
  font-size: 18px;
}
/deep/.el-divider{
  background-color: black;
  height: 20px;
}
.content_right{
  padding: 26px 50px 26px 0;
  /*padding: 26px 0;*/
  width: 1290px;
}
.comment_right{
  padding: 20px 0;
  width: 1290px;
}
.title{
  font-size: 20px;
  line-height: 30px;
}
.tab{
  display: inline-block;
  border: 1px solid #59C264;
  height: 25px;
  box-sizing: border-box;
  padding: 5px 8px;
  font-size: 14px;
  border-radius: 12px;
  line-height: 1;
  color: #59C264;
  background-color: #F0FFF2;
  margin-left: 10px;
}
.tab1{
  display: inline-block;
  border: 1px solid #EFA13E;
  height: 25px;
  box-sizing: border-box;
  padding: 5px 8px;
  font-size: 14px;
  border-radius: 12px;
  line-height: 1;
  color: #EFA13E;
  background-color: #FEF7EE;
  margin-left: 10px;
}
.time{
  display: flex;align-items: center;width: 360px;color: #999999;font-size: 14px;justify-content: space-between
}
.button{
  padding: 24px 0;
  width: 122px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  justify-content: space-between;
  color:  #4D78FF;
  font-size: 14px;
}
.button > div:hover {
  cursor: pointer;
  color: #365DD9;
}
.detail{
  width: 100%;
  min-height: 180px !important;
  padding: 12px 0;
  box-sizing: border-box;
  height: unset !important;
}
.operation{
  display: flex;
  align-items: center;
  float: right;
}
/deep/.el-button{
  border: 1px solid #4D78FF;
  width: 96px;
}
.comment_first{
  padding: 9px 20px 9px 0;
  font-size: 16px;
}
.comment_first_content{
  color: #2F374B;
  margin-bottom: 10px;
}
.comment_first_time{
  width: 410px;
  color: #999999;
}
.comment_first_operation{
  align-items: center;
  display: flex;
  /*width: 100px;*/
}
.operation > img {
  cursor: pointer;
}
.comment_first_operation > img {
  cursor: pointer;
}
.comment_return{
  padding: 10px 0;
  min-height: 60px;
}
.comment_return_content{
  display: flex;
  align-items: center;
}
.comment_return_content>img{
  height: 30px;
  width: 30px;
}
.comment_return_content>.name{
  font-size: 18px;
  color: #2F374B;
  border-right: 1px solid #2F374B;
  padding: 0 8px;
  min-width: 75px;
  box-sizing: border-box;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.comment_return_content>.content{
  font-size: 16px;
  color: #2F374B;
  padding: 0 10px;
}
.comment_return_time{
  padding: 11px 0;
  color: #999999;
  font-size: 14px;
  display: flex;
  align-items: center;
}
.comment_return_time>.button{
  padding: 0 16px;
  display: flex;
  align-items: center;
  width: 50px;
  box-sizing: border-box;
  justify-content: space-between;
  cursor: pointer;
}
.comment_add{
  min-height: 150px;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #DDDDDD;
  padding-bottom: 5px;
}
/deep/.el-textarea__inner{
  resize: none;
  border: unset;
}
.upload{
  padding: 0 6px;
  display: flex;
  align-items: center;
}
.upload>.link{
  cursor: pointer;
  width: 26px;
  height: 26px;
}
.avatar-uploader {
  margin: 0 4px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  width: 42px;
  height: 42px;
  position: relative;
  overflow: hidden;
}
.avatar-uploader:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  color: #C2C2C2;
  width: 42px;
  height: 42px;
  line-height: 42px;
  text-align: center;
}
.avatar {
  width: 42px;
  height: 42px;
  display: block;
}
.pagination{
  padding: 28px 0;
  text-align: right;
}
.comment_pagination {
  text-align: left;
}
/deep/.el-pagination__total{
  font-size:12px;
  color: #999999;
}
/deep/.el-pagination__jump{
  font-size:12px;
  color: #999999;
}
/deep/.el-input__inner{
  color: #999999;
  font-size: 12px;
}
.new_comment{
  padding: 40px 0;
}
/deep/ .ql-editor{
  background-color: #FFFFFF;
  min-height: 480px;
}
.reply{
  text-align: right;
  padding: 24px 0;
}
.comment_add_button{
  display: flex;
  width: 210px;
  align-items: center;
  justify-content: space-between;
}
.comment_add_operation{
  padding: 10px 0;
  float: right;
}
.comment_div{
  padding-right: 10px;
  box-sizing: border-box;
}
.popover_body{
  height: 210px;width: 100%;padding: 16px 40px;box-sizing: border-box
}
.popover_head{
  padding: 0 90px;height: 90px;width: 100%;box-sizing: border-box;display: flex;align-items: center;
}
.popover_head > img {
  width: 88px;height: 88px;
}
.popover_foot {
  padding-top: 10px;
  display: flex;
  height: 80px;
  flex-wrap: wrap;
  align-content: space-around;
  justify-content: flex-start;
}
.popover_foot > div{
  width: 33%;
}
.popover_message{
  padding-left: 27px;
}
.popover_message > div{
  font-size: 20px;
  color: #2F374B;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cancelCollection{
  color: #999999;
}
/deep/.el-radio__input.is-checked+.el-radio__label{
  color: #4D78FF;
}
/deep/.el-radio__input.is-checked .el-radio__inner{
  background: white;
}/deep/.el-radio__inner{
   width: 16px;
   height: 16px;
 }
/deep/.el-radio__inner::after{
  width: 10px;
  height: 10px;
  background-color: #4D78FF;
}
/deep/.detail > p > img{
  max-width: 100%;
}
/deep/.comment_add > .quill-editor > .ql-toolbar.ql-snow {
  display: none;
}
/deep/.comment_add > .quill-editor > .ql-container.ql-snow {
  border: unset;
}
/deep/.comment_add > .quill-editor > .ql-container.ql-snow > .ql-editor {
  min-height: 130px;
}
/deep/.comment_add > .quill-editor > .ql-container.ql-snow > .ql-tooltip {
  display: none;
}
.allContent > p {
  width: 100px;
  cursor:pointer;
  color: #4d78ff;
}
.allContent > p:hover{
  color: #003A6F;
}
/deep/.comment_pagination > ul > li{
  border-radius: 50% !important;
}
/deep/.comment_pagination > button{
  border-radius: 50% !important;
}
</style>
